const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: "currency", currency: "BRL" });

/**
 * 
 * @param {number} entry Valor que deseja formatar.
 * @param {boolean} withoutCoin Para desativar a moeda e retornar somente o valor.
 * Seu valor padrão é `FALSE`
 * @returns {string} Valor formatado.
 */
export const toMoney = (entry, withoutCoin = false) => {
  if (entry != null) {
    const formatted = moneyFormatter.format(entry);
    if (withoutCoin) {
      return formatted.replace(/[^\d.,-]/g, '').trim();
    }
    return formatted;
  }
  return null;
}
